import { isMorphEnvelope, MORPH_FROM, MORPH_TO } from '~/schemas/morph'

/** A morphing param's destination endpoint; scalar readers must go through this, as an envelope throws on `replace`/`split`. */
export const morphToPlain = value => {
	if (isMorphEnvelope(value)) return value[MORPH_TO] ?? value[MORPH_FROM] ?? ''
	return value ?? ''
}
